import { useQuery } from '@tanstack/react-query';

import { ValidatorAccount } from 'src/features/validatorAccounts/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/validations/validator-account/:id/`;

type QueryFnType = typeof queryFn;

interface DTO {
    id: string;
    parkingId: string;
}
const queryFn = ({ id, parkingId }: DTO): Promise<ValidatorAccount> => {
    return axios.get(formatResourcePath(RESOURCE, { id, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as GET_VALIDATOR_ACCOUNT_RESOURCE, useQueryHook as useGetValidatorAccount };
